var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5119_29932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6125 2.5C8.7125 2.5 3.125 8.1 3.125 15C3.125 21.9 8.7125 27.5 15.6125 27.5C22.525 27.5 28.125 21.9 28.125 15C28.125 8.1 22.525 2.5 15.6125 2.5ZM24.275 10H20.5875C20.1875 8.4375 19.6125 6.9375 18.8625 5.55C21.1625 6.3375 23.075 7.9375 24.275 10ZM15.625 5.05C16.6625 6.55 17.475 8.2125 18.0125 10H13.2375C13.775 8.2125 14.5875 6.55 15.625 5.05ZM5.95 17.5C5.75 16.7 5.625 15.8625 5.625 15C5.625 14.1375 5.75 13.3 5.95 12.5H10.175C10.075 13.325 10 14.15 10 15C10 15.85 10.075 16.675 10.175 17.5H5.95ZM6.975 20H10.6625C11.0625 21.5625 11.6375 23.0625 12.3875 24.45C10.0875 23.6625 8.175 22.075 6.975 20ZM10.6625 10H6.975C8.175 7.925 10.0875 6.3375 12.3875 5.55C11.6375 6.9375 11.0625 8.4375 10.6625 10ZM15.625 24.95C14.5875 23.45 13.775 21.7875 13.2375 20H18.0125C17.475 21.7875 16.6625 23.45 15.625 24.95ZM18.55 17.5H12.7C12.5875 16.675 12.5 15.85 12.5 15C12.5 14.15 12.5875 13.3125 12.7 12.5H18.55C18.6625 13.3125 18.75 14.15 18.75 15C18.75 15.85 18.6625 16.675 18.55 17.5ZM18.8625 24.45C19.6125 23.0625 20.1875 21.5625 20.5875 20H24.275C23.075 22.0625 21.1625 23.6625 18.8625 24.45ZM21.075 17.5C21.175 16.675 21.25 15.85 21.25 15C21.25 14.15 21.175 13.325 21.075 12.5H25.3C25.5 13.3 25.625 14.1375 25.625 15C25.625 15.8625 25.5 16.7 25.3 17.5H21.075Z",
    fill: "url(#paint0_linear_5119_29932)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5119_29932",
    x1: -42.3319,
    y1: -33.8269,
    x2: 49.7914,
    y2: -50.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297847,
    stopColor: "#009BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634591,
    stopColor: "#BC658D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5119_29932"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.164062,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.574e10a85690382346a621823813f18d.svg";
export { ForwardRef as ReactComponent };